import { useEffect } from 'react';

// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';

import Snackbar from 'components/@extended/Snackbar';
import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import DisconnectedModal from 'components/DisconnectedModal';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { TenantProvider } from 'contexts/TenantContext';
import ProfilePage from 'layout/MainLayout/Header/HeaderContent/Profile';
import TenantAuthWrapper from 'components/TenantAuthWrapper';
import { initWS } from 'pages/apps/chat/chat-websocket-events';
import SoundNotification from 'utils/SoundNotification';
import NotificationManager from 'components/NotificationManager';
import NotificationPolicyNotice from 'components/NotificationPolicyNotice';

// config
import { SITE_DISABLED } from 'config';
import SiteDisabled from 'pages/maintenance/site-disabled';
import { useSelector } from 'store';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== ////
const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!SITE_DISABLED && isLoggedIn) {
      initWS();
    }
  }, [isLoggedIn]);

  if (SITE_DISABLED) {
    return (
      <TenantProvider>
        <ThemeCustomization>
          <RTLLayout>
            <Locales>
              <ScrollTop>
                <SiteDisabled />
              </ScrollTop>
            </Locales>
          </RTLLayout>
        </ThemeCustomization>
      </TenantProvider>
    );
  }

  // Se está na rota de erro 500, renderiza a tela de erro sem TenantProvider
  if (typeof window !== 'undefined' && window.location.pathname === '/maintenance/error/500') {
    const Error500 = require('pages/maintenance/error/500').default;
    return <Error500 />;
  }
  return (
    <TenantProvider>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <TenantAuthWrapper>
                <AuthProvider>
                  <Notistack>
                    <SoundNotification />
                    <Routes />
                    <ProfilePage />
                    <Snackbar />
                    <DisconnectedModal />
                    <NotificationManager />
                    <NotificationPolicyNotice />
                  </Notistack>
                </AuthProvider>
              </TenantAuthWrapper>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </TenantProvider>
  );
};

export default App;
